import { DuplicateGuard } from './DuplicateGuard.js';

const perfNow = () => globalThis.performance?.now?.() ?? Date.now();

export class DetectionProcessor {
    constructor({
        cooldownMs,
        metrics,
        logger,
        getAdapterName,
        onResult,
        onDuplicate,
        onMetricsChanged,
    }) {
        this.guard = new DuplicateGuard(cooldownMs);
        this.metrics = metrics;
        this.logger = logger;
        this.getAdapterName = getAdapterName;
        this.onResult = onResult;
        this.onDuplicate = onDuplicate;
        this.onMetricsChanged = onMetricsChanged;
        this.lastResult = null;
    }

    handle(result) {
        const text = String(result?.text || '').trim();

        if (!text) {
            return;
        }

        const wallTime = Date.now();

        if (this.guard.isDuplicate(text, wallTime)) {
            this.metrics.recordDiscardedRead();
            this.onDuplicate?.({
                text,
                format: result.format,
                timestamp: new Date(wallTime).toISOString(),
            });
            this.onMetricsChanged?.();
            return;
        }

        const firstRead = this.metrics.readCount === 0;

        this.metrics.recordAcceptedRead(perfNow());
        this.lastResult = {
            text,
            format: result.format || 'Não informado',
            adapter: this.getAdapterName(),
            timestamp: new Date(wallTime).toISOString(),
        };

        if (firstRead) {
            this.logger.info(
                'scanner.first_read',
                'Primeira leitura concluída.',
                this.lastResult
            );
        }

        this.logger.info(
            'scanner.code_found',
            'Código encontrado.',
            this.lastResult
        );
        this.onResult?.({ ...this.lastResult });
        this.onMetricsChanged?.();
    }

    setCooldown(cooldownMs) {
        this.guard.setCooldown(cooldownMs);
    }

    reset() {
        this.guard.clear();
        this.lastResult = null;
    }

    allowNextRead() {
        this.guard.clear();
    }

    get cooldownMs() {
        return this.guard.cooldownMs;
    }
}
